import { types } from 'mobx-state-tree';
import { toasterSvc } from '../services/ToasterSvc';

export const ReoctoStore = types
	.model('ReoctoStore', {
		isTester: false,
		isOffline: false,
		honorLocation: false,
		allowTesterDialog: false,
		useServiceWorkerLoader: false,
		showTesterDialog: false,
		skipTranslation: false,
		refreshPeriod: 5,
		slowRefreshRatio: 20,
		offlineRefreshPeriod: 10,
		useDb: false,
		useNet: true,
		isIdle: false,
		ignoreProblems: false,
	})
	.actions(self => ({
		setIsTester(isTester: boolean) {
			self.isTester = isTester;
		},
		setIsOffline(isOffline: boolean) {
			if (isOffline === self.isOffline) return;
			if (isOffline) {
				toasterSvc.error('http.offline');
			} else {
				toasterSvc.success('http.online');
			}
			self.isOffline = isOffline;
		},
		setHonorLocation(honorLocation: boolean) {
			self.honorLocation = honorLocation;
		},
		setUseServiceWorkerLoader(useServiceWorkerLoader: boolean) {
			self.useServiceWorkerLoader = useServiceWorkerLoader;
		},
		setSkipTranslation(skipTranslation: boolean) {
			self.skipTranslation = skipTranslation;
		},
		setAllowTesterDialog(allowTesterDialog: boolean) {
			self.allowTesterDialog = allowTesterDialog;
		},
		setShowTesterDialog(showTesterDialog: boolean) {
			self.showTesterDialog = showTesterDialog;
		},
		setRefreshPeriod(refreshPeriod: number) {
			self.refreshPeriod = refreshPeriod;
		},
		setSlowRefreshRatio(slowRefreshRatio: number) {
			self.slowRefreshRatio = slowRefreshRatio;
		},
		setOfflineRefreshPeriod(offlineRefreshPeriod: number) {
			self.offlineRefreshPeriod = offlineRefreshPeriod;
		},
		setUseDb(useDb: boolean) {
			self.useDb = useDb;
		},
		setUseNet(useNet: boolean) {
			self.useNet = useNet;
		},
		setIsIdle(isIdle: boolean) {
			if (self.isIdle === isIdle) return;
			console.log('isIdle=' + self.isIdle + '->' + isIdle);
			self.isIdle = isIdle;
		},
		setIgnoreProblems(ignoreProblems: boolean) {
			self.ignoreProblems = ignoreProblems;
		},
	}));
